import React, { useState } from 'react';
import SwapIcon from './SwapIcon';
import ExplorerIcon from './ExplorerIcon';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import { styled, Theme } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';
import useMediaQuery from '@mui/material/useMediaQuery';
import * as RouterLink from 'next/link';

const Item = styled(Box, {
	shouldForwardProp: (propName: PropertyKey) => propName !== 'current',
})<{ current?: boolean }>(({ theme, current = false }) => ({
	padding: theme.spacing(1, 2),
	height: 38,
	display: 'flex',
	userSelect: 'none',
	justification: 'center',
	gap: theme.spacing(0.5),
	cursor: 'pointer',
	alignItems: 'center',
	textDecoration: 'none',
	color: current ? theme.palette.common.textPrimary : theme.palette.common.textSecondary,
	backgroundColor: current ? theme.palette.common.backgroundTertiary : 'transparent',
	'&:hover': {
		color: current ? theme.palette.common.N050 : theme.palette.common.N250,
	},
}));

export default function AppMenu() {
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
	const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

	const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const menuItems = [
		{ label: 'Swap', icon: <SwapIcon />, href: process.env.NEXT_PUBLIC_MAYAN_SWAP_APP },
		{ label: 'Explorer', icon: <ExplorerIcon />, current: true },
	];

	return (
		<div className='flex items-center gap-2'>
			{isMobile ? (
				<>
					<IconButton onClick={handleClick} color="common.textPrimary">
						<MenuIcon />
						<Typography variant='appMediumRegular' sx={{ ml: 0.5 }}>
							Menu
						</Typography>
					</IconButton>
					<Menu
						anchorEl={anchorEl}
						open={Boolean(anchorEl)}
						onClose={handleClose}
					>
						{menuItems.map((item, index) => (
							<MenuItem
								key={index}
								onClick={handleClose}
								// @ts-ignore
								component={item.href ? Link : RouterLink}
								href={item.href ?? '/'}
								target={item.href && !item.current ? '_blank' : undefined}
								selected={item.current}
								sx={{ backgroundColor: 'common.backgroundPrimary', color: item.current ? 'common.textPrimary' : 'common.textSecondary' }}
							>
								{item.icon}
								<Typography variant='appMediumBold' sx={{ ml: 1 }}>
									{item.label}
								</Typography>
							</MenuItem>
						))}
					</Menu>
				</>
			) : (
				menuItems.map((item, index) => (
					<Item
						key={index}
						// @ts-ignore
						component={item.href ? Link : RouterLink}
						// @ts-ignore
						href={item.href ?? '/'}
						target={item.href && !item.current ? '_blank' : undefined}
						current={item.current}
					>
						<Typography variant='appMediumBold'>{item.label}</Typography>
						{item.icon}
					</Item>
				))
			)}
		</div>
	);
}
